import { globalAny } from "../../utils/Utils";
import ComponentThemeType from "../../models/ComponentTheme";
import TouchableButton from "../TouchableButton";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import { StyledButtonContainer, StyledExitPreviewButton, StyledLabel, StyledText } from "./styled";

const ExitPreviewButton = (props: any) => {
	return (
		//@ts-ignore
		<StyledExitPreviewButton isNarrow={props.isNarrow}>
			{/* @ts-ignore */}
			<StyledLabel isNarrow={props.isNarrow}>{globalAny.language.preview_mode}</StyledLabel>
			{/* @ts-ignore */}
			<StyledButtonContainer isNarrow={props.isNarrow}>
				<TouchableButton
					componentTheme={ComponentThemeType.VinFast}
					type={ComponentTypeEnum.Primary}
					onPress={() => props.onPress()}
					isPreview={props.isPreview}
				>
					{/* @ts-ignore */}
					<StyledText isNarrow={props.isNarrow}>{globalAny.language.exit_preview}</StyledText>
				</TouchableButton>
			</StyledButtonContainer>
		</StyledExitPreviewButton>
	);
};

export default ExitPreviewButton;
